import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";
import LoginForm from "./components/LoginForm";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import ResetPasswordForm from "./components/ResetPasswordForm";
import Profile from "./components/Profile";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import ActivityFeed from "./components/ActivityFeed";
import BrowseUsers from "./components/BrowseUsers";
import Matches from "./components/Matches";
import Conversations from "./components/Conversations";
import Home from "./components/Home";
import Footer from "./components/Footer";
import CookieConsentBanner from "./components/CookieConsentBanner";
import { AuthProvider } from "./context/AuthContext";
import SentLikes from "./components/SentLikes";
import ReceivedLikes from "./components/ReceivedLikes";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ServiceRules from "./components/ServiceRules";
import About from "./components/About";
import CookiePolicy from "./components/CookiePolicy";
import PaymentReturn from "./components/PaymentReturn";
import PaymentHistory from "./components/PaymentHistory";
import { I18nProvider } from "./i18n";
import { trackPageView } from "./utils/analytics";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />
          <AnalyticsTracker />
          <div className="app">
            <Navbar />
            <ActivityFeed />

          <main className="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/register" element={<RegistrationForm />} />
              <Route path="/login" element={<LoginForm />} />
              <Route path="/forgot-password" element={<ForgotPasswordForm />} />
              <Route path="/reset-password" element={<ResetPasswordForm />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/service-rules" element={<ServiceRules />} />
              <Route path="/rules" element={<ServiceRules />} />
              <Route path="/about" element={<About />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/payment/return" element={<PaymentReturn />} />

              <Route
                path="/payments"
                element={<ProtectedRoute><PaymentHistory /></ProtectedRoute>}
              />

              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/browse"
                element={
                  <ProtectedRoute>
                    <BrowseUsers />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/matches"
                element={
                  <ProtectedRoute>
                    <Matches pageType="matches" />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/messages"
                element={
                  <ProtectedRoute>
                    <Conversations />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/messages/:matchId"
                element={
                  <ProtectedRoute>
                    <Conversations />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/likes/sent"
                element={
                  <ProtectedRoute>
                    <SentLikes />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/likes/received"
                element={
                  <ProtectedRoute>
                    <ReceivedLikes />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>

          <Footer />
          <CookieConsentBanner />
          </div>
        </Router>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
